import type { ItemRegistryV1, PlayerCharacter, Resistance } from "./types";
const ZERO: Resistance = { fire: 0, water: 0, thunder: 0, ice: 0, dragon: 0 };
export function calculateDerived(
  player: PlayerCharacter,
  registry: ItemRegistryV1,
) {
  let attack = 10,
    defense = 1,
    resistances = { ...ZERO };
  for (const ref of Object.values(player.equipped)) {
    if (!ref) continue;
    const meta = registry.definitions[ref.itemKey]?.meta;
    if (meta?.kind === "weapon") attack += meta.attack;
    if (meta?.kind === "armor") {
      defense += meta.defense;
      for (const key of Object.keys(ZERO) as (keyof Resistance)[])
        resistances[key] += meta.resistances[key];
    }
  }
  return { attack, defense, resistances };
}
